import Fetch from './fetch';
import FetchPromise from './fetch-promise';
import HttpUtils from './http-utils';

const USERS = 'users';

const UsersApi = {
  search: ({ term, limit = 5 }) =>
    FetchPromise.get(HttpUtils.buildUriWithQueryString(`${USERS}/search`, { term, limit })),
  getAcademyAdmins: ({ data }) => FetchPromise.get(HttpUtils.buildUriWithQueryString(`${USERS}/academy_admins`, data)),
  bulkUpdate: ({ data }) => FetchPromise.put(USERS, data),
  bulkDelete: ({ data }) => FetchPromise.delete(USERS, data),
  bulkAssignMentors: ({ data }) => FetchPromise.post(`${USERS}/mentors`, data),
  bulkAssignGroups: ({ data }) => FetchPromise.post(`${USERS}/groups`, data),
  createInvitation: ({ data }) => FetchPromise.post(`${USERS}/invitations`, data),
  resendInvitations: () => FetchPromise.put(`${USERS}/resend_invitation`),
  addDismissedAlertObject: (objectId, objectType) =>
    Fetch.post('users/dismiss_assigned_alert_object', { object_id: objectId, object_type: objectType }),
  user: {
    get: ({ userId }) => FetchPromise.get(`${USERS}/${userId}`),
    update: ({ userId, data }) => FetchPromise.put(`${USERS}/${userId}`, data),
    delete: ({ userId }) => FetchPromise.delete(`${USERS}/${userId}`, { should_destroy: true }),
    activate: ({ userId }) => FetchPromise.put(`${USERS}/${userId}`, { is_deleted: false }),
    deactivate: ({ userId }) => FetchPromise.delete(`${USERS}/${userId}`),
    resendInvitation: ({ userId }) => FetchPromise.post(`${USERS}/${userId}/resend_invitation`),
    assignMentor: ({ userId, data }) => FetchPromise.post(`${USERS}/${userId}/mentors`, data),
    deleteMentor: ({ userId, data }) => FetchPromise.delete(`${USERS}/${userId}/mentors`, data),
    assignGroup: ({ userId, data }) => FetchPromise.post(`${USERS}/${userId}/groups`, data),
    instantLogin: ({ userId }) => FetchPromise.post(`${USERS}/${userId}/instant_login`),
    instantLogout: ({ userId }) => FetchPromise.post(`${USERS}/${userId}/instant_logout`),
    isLimitedEditorOfFolder: ({ userId, folderId }) =>
      FetchPromise.get(`${USERS}/${userId}/is_limited_editor_of_folder/${folderId}`),
    isEditorOfFolder: ({ userId, folderId }) => FetchPromise.post(`${USERS}/${userId}/is_editor_of_folder/${folderId}`),
    isManagerOfUser: ({ userId, folderId }) => FetchPromise.post(`${USERS}/${userId}/is_manager_of_user/${folderId}`),
  },
  notifications: {
    get: ({ userId }) => FetchPromise.get(`${USERS}/${userId}/notifications`),
    count: ({ userId }) => FetchPromise.get(`${USERS}/${userId}/notifications/count`),
    read: ({ userId }) => FetchPromise.post(`${USERS}/${userId}/notifications/read`),
  },
};
export default UsersApi;
